module.exports = __webpack_public_path__ + "static/media/calendar-icon.c0b43871.svg";